<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="white">
        <v-toolbar-title>Costos</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-col cols="2" class="mt-5 mx-1 pa-1">
          <v-text-field
            type="date"
            class="text-xs-center"
            label="Desde"
            hide-details
            v-model="fechaInicio"
            :max="new Date().toISOString().substr(0, 10)"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="mt-5 mr-2 pa-1">
          <v-text-field
            type="date"
            class="text-xs-center"
            label="Hasta"
            hide-details
            v-model="fechaFin"
            :max="new Date().toISOString().substr(0, 10)"
          ></v-text-field>
        </v-col>
        <v-btn @click="listar()" color="primary">Consultar</v-btn>
      </v-toolbar>

      <v-container>
        <v-row
          no-gutters
          class="ma-2 borderLine colorRow"
          v-for="(itemC, indexC) in itemsCosto"
          :key="indexC"
        >
          <!-- nombre de cartera -->
          <v-col cols="12" class="pt-3"
            ><p class="text-center font-weight-black">
              {{ itemC.cartera }}
            </p></v-col
          >
          <!-- # asistencias x tipo servicio -->
          <v-col cols="6" class="pl-3">
            <v-card elevation="0" tile color="transparent">
              <p class="text-center">
                Número de asistencias por tipo de servicio
              </p>
              <v-card-text style="height: 250px; overflow-y: scroll">
                <v-list two-line color="transparent">
                  <template v-for="(itemTS, indexTS) in itemsTipoServicio">
                    <v-list-item
                      :key="itemTS.title"
                      v-if="itemTS.cartera == itemC.cartera"
                    >
                      <v-list-item-content
                        v-for="(i, j) in itemsTipoServicio[indexTS].nombre"
                        :key="j"
                      >
                        <v-list-item-title class="text-center">{{
                          i.tipoServicio
                        }}</v-list-item-title>

                        <v-list-item-title class="text-center">
                          {{ i.cantidad }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- $ por tipo de asistencia -->
          <v-col cols="6">
            <v-card elevation="0" tile color="transparent">
              <p class="text-center">
                Costo de servicio por tipo de asistencia
              </p>
              <v-card-text style="height: 250px; overflow-y: scroll">
                <v-list two-line color="transparent">
                  <template v-for="(itemTA, indexTA) in itemsTipoAsistencia">
                    <v-list-item
                      :key="itemTA.title"
                      v-if="itemTA.cartera == itemC.cartera"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list color="transparent" class="pa-0">
                          <v-list-item
                            class="pa-0"
                            v-for="(i, j) in itemsTipoAsistencia[indexTA]
                              .nombre"
                            :key="j"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                >{{ i.tipoAsistencia }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-list-item-action-text class="subtitle-1">
                                ${{ (i.cantidad).toFixed(2) }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" class="mt-5">
            <p class="text-center title mb-0">Costo por cuenta</p>
            <p class="text-center title">${{ (itemC.costoServicio).toFixed(2) }}</p>
          </v-col>
        </v-row>
      </v-container>

      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackValidacion" color="cyan darken-2" right top
        >Los campos de Fecha inicio y Fecha Fin no deben estar
        vacios.</v-snackbar
      >
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      dialog: false,
      CostoxServicio: [],
      CantidadxTipoServicio: [],
      CostoxTipoAsistencia: [],
      search: "",
      fechaInicio: "",
      fechaFin: "",
      overlay: false,
      snackValidacion: false,
      itemsCosto: [],
      itemsTipoAsistencia: [],
      itemsTipoServicio: [],
    };
  },

  methods: {
    async listar() {
      let me = this;
      me.listarxTipoServicio();
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (me.fechaInicio != "" && me.fechaFin != "") {
        me.overlay = true;
        me.limpiar();

        await axios
          .get(
            "api/Asegurados/sumaCostos/" + me.fechaInicio + "/" + me.fechaFin,
            configuracion
          )
          .then(function (response) {
            me.CostoxServicio = response.data;
            me.overlay = false;

            for (var i = 0; i < me.CostoxServicio.length; i++) {
              var index = me.itemsCosto.findIndex((object) => {
                return object.cartera == me.CostoxServicio[i].cartera;
              });
              if (index != -1) {
                //esta linea suma los costos por cartera
                me.itemsCosto[index].costoServicio =
                  me.itemsCosto[index].costoServicio +
                  me.CostoxServicio[i].costoServicio;
              } else {
                //si no existe el indice en el arreglo se agrega el item
                me.itemsCosto.push({
                  cartera: me.CostoxServicio[i].cartera,
                  costoServicio: me.CostoxServicio[i].costoServicio,
                });
              }
            }

            for (var i = 0; i < me.CantidadxTipoServicio.length; i++) {
              var index = me.itemsTipoServicio.findIndex((object) => {
                return object.cartera == me.CantidadxTipoServicio[i].cartera;
              });

              if (index != -1) {
                me.itemsTipoServicio[index].nombre.push({
                  tipoServicio: me.CantidadxTipoServicio[i].tipoServicio,
                  cantidad: me.CantidadxTipoServicio[i].cantidad,
                });
              } else {
                me.itemsTipoServicio.push({
                  cartera: me.CantidadxTipoServicio[i].cartera,
                  nombre: [
                    {
                      tipoServicio: me.CantidadxTipoServicio[i].tipoServicio,
                      cantidad: me.CantidadxTipoServicio[i].cantidad,
                    },
                  ],
                });
              }
            }

            for (var i = 0; i < me.CostoxServicio.length; i++) {
              var index = me.itemsTipoAsistencia.findIndex((object) => {
                return object.cartera == me.CostoxServicio[i].cartera;
              });

              if (index != -1) {
                me.itemsTipoAsistencia[index].nombre.push({
                  tipoAsistencia: me.CostoxServicio[i].tipoAsistencia,
                  cantidad: me.CostoxServicio[i].costoServicio,
                });
              } else {
                me.itemsTipoAsistencia.push({
                  cartera: me.CostoxServicio[i].cartera,
                  nombre: [
                    {
                      tipoAsistencia: me.CostoxServicio[i].tipoAsistencia,
                      cantidad: me.CostoxServicio[i].costoServicio,
                    },
                  ],
                });
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        me.snackValidacion = true;
      }
    },
    async listarxTipoServicio() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      await axios
        .get(
          "api/Asegurados/cantidadxTipoServicio/" +
            this.fechaInicio +
            "/" +
            this.fechaFin,
          configuracion
        )
        .then((response) => {
          this.CantidadxTipoServicio = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    limpiar() {
      this.CostoxServicio = [];
      this.itemsCosto = [];
      this.itemsTipoServicio = [];
      this.itemsTipoAsistencia = [];
    },
  },
};
</script>
<style>
.borderLine {
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
.scroll {
  overflow-y: auto;
}
.colorRow {
  background-color: #faf9f9;
}
</style>